import { lazy } from 'react';
import { AppRoute } from './route.types';
import { Loadable } from '@components/lazy-load/loadable';

const ModuleLogin = Loadable(lazy(() => import('@modules/auth/login/login.page')));
const ModuleRegister = Loadable(lazy(() => import('@modules/auth/register/register.page')));
const ModuleFederatedSignIn = Loadable(lazy(() => import('@modules/auth/oauth/oauth.page')));
const ModuleCheckoutConfirmation = Loadable(
  lazy(() => import('@modules/auth/sign-up/components/confirmation/checkout-confirmation'))
);
const ModuleForgotPassword = Loadable(lazy(() => import('@modules/auth/forgot-password/forgot-password.page')));
const ModuleVerifyMfaOtpPage = Loadable(lazy(() => import('@modules/auth/mfa/verify-mfa-otp.page')));
const ModuleVerifyMfaTotpPage = Loadable(lazy(() => import('@modules/auth/mfa/verify-mfa-totp.page')));
const ModuleResetpassword = Loadable(lazy(() => import('@modules/auth/reset-password/reset-password.page')));
const ModuleMemberInvitation = Loadable(lazy(() => import('@modules/auth/invitation/member-invitation.page')));
const ModuleResetpasswordSuccess = Loadable(
  lazy(() => import('@modules/auth/reset-password-success/reset-password-success.page'))
);
const ModulePreserveRedirectToLogin = Loadable(lazy(() => import('@modules/auth/common/preserve-redirect-to-login')));
// New Signup Routes
const Signup = Loadable(lazy(() => import('@modules/auth/sign-up/pages/account/sign-up/sign-up.page')));
const VerifyEmail = Loadable(lazy(() => import('@modules/auth/sign-up/pages/account/verify-email/verify-email')));
const ChoosePlan = Loadable(lazy(() => import('@modules/auth/sign-up/pages/choose-plan/choose-plan.view')));
const EnterprisePlan = Loadable(lazy(() => import('@modules/auth/sign-up/pages/choose-plan/enterprise-plan')));
const PaymentConfirmation = Loadable(
  lazy(() => import('@modules/auth/sign-up/pages/checkout/payment-confirmation.view'))
);
const PaymentSuccess = Loadable(lazy(() => import('@modules/auth/sign-up/pages/payment-success/payment-success')));
const AppRedirectCenter = Loadable(lazy(() => import('@modules/app-redirection-center/app-redirection-center.page')));
const DemoDashboard = Loadable(lazy(() => import('@modules/demo/demo.app')));

const signupRoutes: AppRoute[] = [
  {
    type: 'render',
    path: '/sign-up',
    component: Signup,
  },
  {
    type: 'render',
    path: '/account-verification',
    component: VerifyEmail,
  },
  {
    type: 'render',
    path: '/select-plan',
    component: ChoosePlan,
  },
  {
    type: 'render',
    path: '/select-plan/enterprise',
    component: EnterprisePlan,
  },
  {
    type: 'render',
    path: '/confirm-payment',
    component: PaymentConfirmation,
  },
  {
    type: 'render',
    path: '/success/:plan',
    component: PaymentSuccess,
  },
];

export const appPublicRoutes: AppRoute[] = [
  ...signupRoutes,
  {
    type: 'parent',
    path: '/login',
    children: [
      {
        type: 'render',
        path: '/',
        component: ModuleLogin,
      },
      {
        type: 'render',
        path: '/verify-otp',
        component: ModuleVerifyMfaOtpPage,
      },
      {
        type: 'render',
        path: '/verify-totp',
        component: ModuleVerifyMfaTotpPage,
      },
    ],
  },

  {
    type: 'render',
    path: '/checkout/confirmation',
    component: ModuleCheckoutConfirmation,
  },
  {
    type: 'render',
    path: '/auth/invitation/:token',
    component: ModuleMemberInvitation,
  },
  {
    type: 'parent',
    path: '/forgot-password',
    children: [
      {
        type: 'render',
        path: '/',
        component: ModuleForgotPassword,
      },
      {
        type: 'render',
        path: '/verify-otp',
        component: ModuleResetpassword,
      },
    ],
  },
  {
    type: 'render',
    path: '/password-reset-success',
    component: ModuleResetpasswordSuccess,
  },
  {
    type: 'render',
    path: '/payment-request',
    component: ModulePreserveRedirectToLogin,
  },
];

export const demoRoutes: AppRoute[] = [
  {
    type: 'render',
    path: '/demo/*',
    component: DemoDashboard,
  },
];

export const basePublicRoutes: AppRoute[] = [
  {
    type: 'render',
    path: '/app-redirect/:mode',
    component: AppRedirectCenter,
  },
  {
    type: 'render',
    path: '/auth/register',
    component: ModuleRegister,
  },
  {
    type: 'render',
    path: '/auth/callback',
    component: ModuleFederatedSignIn,
  },
];
